import { Box } from "@mui/material";

import { ReferralProgramStatus } from "@framework/types";
import { Switch } from "@dzambalaorg/ui-kit";

export interface IStatusSwitchProps {
  status: ReferralProgramStatus | null;
  isLoading?: boolean;
  onChange: (value: ReferralProgramStatus) => Promise<void>;
}

export const StatusSwitch = (props: IStatusSwitchProps) => {
  const { status, isLoading, onChange } = props;

  const handleChange = async (_event: any, value: boolean) => {
    await onChange(value ? ReferralProgramStatus.ACTIVE : ReferralProgramStatus.INACTIVE);
  };

  return (
    <Box>
      <Switch
        checked={status === ReferralProgramStatus.ACTIVE}
        disabled={isLoading || status === null}
        onChange={handleChange}
      />
    </Box>
  );
};
